import apiClient from '../api';

const hasValue = (value) => value !== null && value !== undefined && String(value).trim() !== '';

export async function listPlayers(filters = {}) {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
        if (hasValue(value)) {
            params.append(key, value);
        }
    });

    const query = params.toString();
    const endpoint = query ? `/players/summary?${query}` : '/players/summary';

    const { data } = await apiClient.get(endpoint);
    return data;
}

export async function deletePlayer(playerId) {
    if (!hasValue(playerId)) {
        throw new Error('No se puede eliminar un jugador sin ID');
    }

    await apiClient.delete(`/players/${playerId}`);
}
